export default "__VITE_ASSET__zmFhNkGF__"